import { IconConfig } from '@dev-fast/types';

export const iconsPromocodeDesign: IconConfig[] = [
  {
    name: 'promo-ticket',
    path: 'assets/img/design/promocode/promo-ticket.svg',
  },
];
